import React from 'react';

import PageHeader from '@components/common/headers/page-header/PageHeader';
import SiteHelmet from '@components/common/site-helmet/SiteHelmet';
import ErrorTracker from 'errors/error-tracker/ErrorTracker';
import './PageWrapper.sass';

declare interface PageWrapperProps {
    headerInfo?: React.ReactNode;
    headerNavigation?: React.ReactNode;
    headerDisableSearch?: boolean;
    disableDownloadReport?: boolean;
    disableDatepicker?: boolean;
    publicationDate?: React.ReactNode;
    wrapperId?: string;
    pageTitle: string;
    filter?: React.ReactNode;
    logs?: string[];
    children: React.ReactNode;
    shouldHideFilters?: boolean;
    ref?: (node?: Element) => void;
    widgetWrapperStye?: React.CSSProperties
}

const PageWrapper = ({
    headerInfo,
    headerNavigation,
    headerDisableSearch,
    disableDownloadReport,
    disableDatepicker,
    publicationDate,
    wrapperId,
    filter,
    logs,
    children,
    pageTitle,
    shouldHideFilters,
    ref,
    widgetWrapperStye
}: PageWrapperProps) => (
    <div className={'page-wrapper'} id={wrapperId} ref={ref}>
        <PageHeader
            headerInfo={headerInfo}
            headerNavigation={headerNavigation}
            headerDisableSearch={headerDisableSearch}
            disableDownloadReport={disableDownloadReport}
            disableDatepicker={disableDatepicker}
            publicationDate={publicationDate}
            shouldHideFilters={shouldHideFilters}
        />
        <SiteHelmet title={pageTitle} />
        {filter}

        <div className="widgets-wrapper" style={widgetWrapperStye}>
            {children}
        </div>

        <ErrorTracker logs={logs} />
    </div>
);

export default PageWrapper;
